module.exports = __webpack_public_path__ + "img/developmentHistory.e37614c5.jpg";